import { Provider as SlotProvider } from '@gestionale-immobiliare/react-slot-fill';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Error } from 'gtx-react/components/Error/Error';
import { SentryErrorHandler } from 'gtx-react/sentry';

const container = document.getElementById('root');
const root = createRoot(container);

/**
 * This function will render the GtxApp provided
 * Will wrap the app with SentryErrorHandler
 * and the SlotProvider.
 *
 * @param App
 * @returns
 */
export const GtxMainRender = (App) =>
    root.render(
        <SentryErrorHandler fallback={<Error />}>
            <SlotProvider>
                <App />
            </SlotProvider>
        </SentryErrorHandler>
    );
